export type DreGroup = 'GROSS_REVENUE' | 'DEDUCTIONS' | 'COGS' | 'OPERATING_EXPENSES' | 'FINANCIAL' | 'TAXES';

export interface SystemFinanceCategory {
  systemKey: string;
  name: string;
  type: 'INCOME' | 'EXPENSE';
  dreGroup: DreGroup;
  /** Fora da DRE (ex.: compra de mercadoria vira estoque; o custo entra pelo CMV na venda). */
  excludeFromDre?: boolean;
}

/** Categorias financeiras de sistema criadas para todo tenant novo. */
export const FINANCE_SYSTEM_CATEGORIES: SystemFinanceCategory[] = [
  { systemKey: 'sales', name: 'Vendas', type: 'INCOME', dreGroup: 'GROSS_REVENUE' },
  { systemKey: 'other_income', name: 'Outras receitas', type: 'INCOME', dreGroup: 'GROSS_REVENUE' },
  { systemKey: 'refunds', name: 'Devoluções e estornos', type: 'EXPENSE', dreGroup: 'DEDUCTIONS' },
  { systemKey: 'sales_taxes', name: 'Impostos sobre vendas', type: 'EXPENSE', dreGroup: 'DEDUCTIONS' },
  { systemKey: 'cogs', name: 'Custo das mercadorias vendidas', type: 'EXPENSE', dreGroup: 'COGS' },
  { systemKey: 'cogs_reversal', name: 'Estorno de custo das mercadorias', type: 'INCOME', dreGroup: 'COGS' },
  { systemKey: 'gateway_fees', name: 'Taxas de pagamento', type: 'EXPENSE', dreGroup: 'OPERATING_EXPENSES' },
  { systemKey: 'platform_fees', name: 'Comissão da plataforma', type: 'EXPENSE', dreGroup: 'OPERATING_EXPENSES' },
  { systemKey: 'shipping', name: 'Frete', type: 'EXPENSE', dreGroup: 'OPERATING_EXPENSES' },
  { systemKey: 'ads', name: 'Anúncios', type: 'EXPENSE', dreGroup: 'OPERATING_EXPENSES' },
  { systemKey: 'rent', name: 'Aluguel', type: 'EXPENSE', dreGroup: 'OPERATING_EXPENSES' },
  { systemKey: 'other_expenses', name: 'Outras despesas', type: 'EXPENSE', dreGroup: 'OPERATING_EXPENSES' },
  { systemKey: 'bank_fees', name: 'Tarifas bancárias e juros', type: 'EXPENSE', dreGroup: 'FINANCIAL' },
  { systemKey: 'das', name: 'DAS / impostos', type: 'EXPENSE', dreGroup: 'TAXES' },
  {
    systemKey: 'stock_purchases',
    name: 'Compra de mercadorias',
    type: 'EXPENSE',
    dreGroup: 'COGS',
    excludeFromDre: true,
  },
];

/** Categorias que não são dinheiro entrando ou saindo (ficam fora do fluxo de caixa). */
export const NON_CASH_CATEGORY_KEYS = ['cogs', 'cogs_reversal'] as const;
/** Categorias fora da DRE (compra de mercadoria vira estoque; o custo entra pelo CMV na venda). */
export const NON_DRE_CATEGORY_KEYS = FINANCE_SYSTEM_CATEGORIES.filter((c) => c.excludeFromDre).map((c) => c.systemKey);

export const FINANCIAL_ACCOUNT_TYPES = ['CASH', 'BANK', 'GATEWAY'] as const;
/** Alertas do limite do MEI, em % do limite anual. */
export const MEI_ALERT_LEVELS = [70, 90, 100] as const;
/** Fallback do limite anual do MEI (o valor vigente vem de `platform_settings.mei_annual_limit_cents`). */
export const MEI_DEFAULT_ANNUAL_LIMIT_CENTS = 8_100_000;
